import { Injectable } from '@angular/core';
import { AppSettings, AsamcoAuthService } from '@asamco/base';
import { bind } from '@asamco/utils';
import { Observable, Subject } from 'rxjs';

import { AsamcoSignalrBase } from '@asamco/signal-r';
import { LinkStatusCode } from '../../enums/link-status-code.enum';
import { LinkStatus } from '../../interfaces/link-status.interface';
import { LinkButtonStatus } from '../../interfaces/link-button-status.interface';

@Injectable({
	providedIn: 'root',
	deps: [AsamcoAuthService, AppSettings],
})
export class LinkStatusSignalrService extends AsamcoSignalrBase {
	/**
	 * Our hubname to connect to
	 */
	protected hubName = 'linkStatus';

	/**
	 * The event name
	 */
	protected events = [{ methodName: 'linkStatusUpdate', newMethod: this.linkStatusUpdate }, { methodName: 'linkButtonUpdate', newMethod: this.linkButtonUpdate }];
	//protected buttonUpdate = [{ methodName: 'linkButtonUpdate', newMethod: this.linkButtonUpdate }];

	private linkStatusSubject: Subject<LinkStatus> = new Subject<LinkStatus>();
	private linkButtonSubject: Subject<LinkButtonStatus>  = new Subject<LinkButtonStatus>();

	/**
	 *Creates an instance of NotificationSignalrService.
	 * @param signalr
	 * @param auth
	 * @param app
	 */
	constructor(auth: AsamcoAuthService, app: AppSettings) {
		super(auth, app);

		this.startService().subscribe({error: console.error});
	}

	@bind
	linkButtonUpdate(linkID: number, linkIsRunning: boolean) {
		this.linkButtonSubject.next({ linkID: linkID, isLinkRunning: linkIsRunning } as LinkButtonStatus);
	}

	@bind
	linkStatusUpdate(linkID: number, status: string, statusCode: LinkStatusCode) {
		this.linkStatusSubject.next({ linkID, status, statusCode } as LinkStatus);
	}

	public getLinkStatusObservable(): Observable<LinkStatus> {
		return this.linkStatusSubject.asObservable();
	}

	public getLinkButtonObservable(): Observable<LinkButtonStatus> {
		return this.linkButtonSubject.asObservable();
	}
}
